module.exports = __webpack_public_path__ + "img/bonusIntroducing.1972a8c1.webp";